import { Component } from "preact";
import common from "../../../../utils/common";
import { logEvent } from "../../../../utils/logger";

export default class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = { isError: false, errorName: "", inputValue: "" };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  }

  updateValue = event => {
    if (event && event.target) {
      this.setState({ inputValue: event.target.value.trim() });
      this.props.updateFormValue(this.props.index, this.state.inputValue);
    }
  };

  clearErrors = () => {
    if (this.state.isError && !common.isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "text form field", fieldName: this.props.name });
  };

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.inputValue == this.props.inputValue &&
      nextProps.isError == this.props.isError &&
      nextProps.errorName == this.props.errorName
    ) {
      return false;
    }
  }

  render({ name, constraints, placeholder, subText }) {
    const maxLength = constraints.maxLength ? constraints.maxLength : "";
    return (
      <div>
        <input
          name={name}
          type="text"
          value={this.state.inputValue}
          placeholder={placeholder}
          maxlength={maxLength}
          onChange={this.updateValue}
          onFocus={this.clearErrors}
          autocomplete="off"
        />
        {subText && <p className="input-info">{subText}</p>}
        {this.state.isError && (
          <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
            {this.state.errorName}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/text/index.js